import { useState, useEffect } from "react";
import { LazyLoadImage } from "react-lazy-load-image-component";
import "react-lazy-load-image-component/src/effects/blur.css";
import Plan from "./Plan";
import plansResidence from "../../data/home_borin/plansResidence.json";
import ImgSlider from "./ImgSlider";
import socialAreasResidence from "../../data/home_borin/socialAreasResidence.json";

function Residence() {
  const [imageSrc, setImageSrc] = useState(
    "/home_borin/assets/images/residence/residence.webp"
  );

  useEffect(() => {
    const updateImage = () => {
      if (window.innerWidth < 1024) {
        setImageSrc("/home_borin/assets/images/residence/residence-mobile.webp");
      } else {
        setImageSrc("/home_borin/assets/images/residence/residence.webp");
      }
    };

    // Chama a função na montagem do componente
    updateImage();

    // Adiciona o event listener para atualizar a imagem ao redimensionar
    window.addEventListener("resize", updateImage);

    // Remove o event listener ao desmontar o componente
    return () => window.removeEventListener("resize", updateImage);
  }, []);

  return (
    <>
      <section id="id_residence" className="header-residence">
        <div className="container">
          <div className="content bg-white">
            <div className="col-lg-12">
              <div className="image-wrapper wow zoomIn slow">
                <LazyLoadImage
                  src={imageSrc}
                  alt="Residência Wiser"
                  effect="blur"
                  width={'100%'}
                  height={"100%"}
                />
              </div>
            </div>
            <div className="col-lg-11 d-flex justify-self-end bg-white flex-wrap">
              <div className="col-lg-6 legacy p-100">
                <div className="d-flex">
                  <div className="logo text-center d-inline-block me-20 img wow zoomIn slow">
                    <LazyLoadImage
                      src="/home_borin/assets/images/logo.svg"
                      alt="logo da Wiser"
                      effect="blur"
                      width={"68px"}
                      height={"93px"}
                    />
                  </div>
                  <h2 className="js-splittext-lines color-gray align-content-center">
                    <small className="fsz-20 ltspc-5 fw-400">LEGACY</small>{" "}
                    <br />
                    <span className="fsz-60 color-brown1 text-uppercase font-palast-regular ltspc-10 title-residence">
                      RESIDENCE
                    </span>
                  </h2>
                </div>
                <p
                  className="fsz-16 color-gray mt-15 wow zoomIn slow ltspc-2 lh-1"
                  data-wow-delay="0.2s"
                >
                  Um conceito de moradia que transcende o tempo. O Legacy
                  Residence foi criado para aqueles que valorizam exclusividade
                  e elegância em cada detalhe. Aqui, morar não é apenas habitar
                  um espaço, é viver uma experiência de sofisticação e conforto
                  incomparáveis. Combinando design atemporal, tecnologia de
                  ponta e localização privilegiada, redefinimos o significado de
                  viver com sabedoria.
                </p>

                <div className="mt-50 wow zoomIn slow">
                  <h4 className="fsz-24 lh-1 ltspc-1 font-palast-regular">
                    Apartamentos
                    <strong className="color-brown1 font-palast-bold-italic">
                      {" "}
                      Elevados
                    </strong>
                  </h4>
                  <p className="mt-10 mb-40 color-gray lh-1 ltspc-1">
                    Oferecendo vistas privilegiadas e total privacidade.
                  </p>
                </div>

                <div className="mt-50 wow zoomIn slow">
                  <h4 className="fsz-24 lh-1 ltspc-1 font-palast-regular">
                    Pé-direito
                    <strong className="color-brown1 font-palast-bold-italic">
                      {" "}
                      Duplo
                    </strong>
                  </h4>
                  <p className="mt-10 mb-40 color-gray lh-1 ltspc-1">
                    Amplitude e elegância que inspiram conforto e bem-estar.
                  </p>
                </div>

                <div className="mt-50 wow zoomIn slow">
                  <h4 className="fsz-24 lh-1 ltspc-1 font-palast-regular">
                    Automação
                    <strong className="color-brown1 font-palast-bold-italic">
                      {" "}
                      Completa
                    </strong>
                  </h4>
                  <p className="mt-10 mb-40 color-gray lh-1 ltspc-1">
                    Tecnologia de ponta para um estilo de vida inteligente.
                  </p>
                </div>

                <div className="mt-50 wow zoomIn slow">
                  <h4 className="fsz-24 lh-1 ltspc-1 font-palast-regular">
                    Lazer
                    <strong className="color-brown1 font-palast-bold-italic">
                      {" "}
                      Exclusivo
                    </strong>
                  </h4>
                  <p className="mt-10 mb-40 color-gray lh-1 ltspc-1">
                    Um horizonte privado para momentos inesquecíveis.
                  </p>
                </div>

                <div className="mt-50 wow zoomIn slow">
                  <h4 className="fsz-24 lh-1 ltspc-1 font-palast-regular">
                    Localização
                    <strong className="color-brown1 font-palast-bold-italic">
                      {" "}
                      Ímpar
                    </strong>
                  </h4>
                  <p className="mt-10 mb-40 color-gray lh-1 ltspc-1">
                    No coração de Passo Fundo, com tudo ao seu redor.
                  </p>
                </div>
              </div>

              <div className="col-lg-5 p-80 align-content-center wow zoomIn slow">
                <h3 className="lh-1">
                  <span className="fsz-35 color-gray font-palast-regular">
                    O lugar dos seus
                  </span>
                  <strong className="fsz-40 color-brown2 font-palast-bold-italic">
                    {" "}
                    melhores momentos{" "}
                  </strong>
                  <span className="fsz-35 color-gray font-palast-regular">
                    te espera.
                  </span>
                </h3>

                <p className="fsz-16 mt-30 mb-20 color-gray lh-2 ltspc-2">
                  Um universo de experiências exclusivas, revelando um ambiente
                  projetado para oferecer conforto, entretenimento e bem-estar.
                </p>

                <p className="fsz-16 mb-20 color-gray lh-2 ltspc-2">
                  Com espaços integrados que harmonizam elegância e
                  funcionalidade, a estrutura foi pensada para atender a todos
                  os momentos do dia, desde a diversão das crianças até o
                  elaxamento dos adultos.
                </p>

                <button
                  onClick={() => window.openModal()}
                  className="butn border rounded-pill border-brown1 hover-bg-brown1 text-uppercase color-brown1 mt-20 ms-auto wow zoomIn slow"
                >
                  <span className="ltspc-1"> Quero saber mais </span>
                </button>
              </div>
            </div>
          </div>
        </div>
      </section>

      <section className="tc-slider-style" style={{ position: "relative" }}>
        <ImgSlider slides={socialAreasResidence} />
      </section>

      <Plan
        id={'plan-residence'}
        title={"Plantas"}
        subTitle={"Residence"}
        slides={plansResidence}
        bgColor={"plan-bg-warm-gay"}
      />
    </>
  );
}

export default Residence;
